import { JSONEditor } from '@json-editor/json-editor'
import _ from 'lodash'
import Choices from 'choices.js'

const StringEditor = JSONEditor.defaults.editors.string

class CSVArray extends StringEditor {
  build () {
    const directionsLabel = this.options.directionsLabel || 'Type a tag and press enter to add it to the list'
    if (!this.options.compact) this.header = this.label = this.theme.getFormInputLabel(directionsLabel, this.isRequired())
    if (this.schema.description) this.description = this.theme.getFormInputDescription(this.translateProperty(this.schema.description))
    if (this.options.infoText) this.infoButton = this.theme.getInfoButton(this.translateProperty(this.options.infoText))

    this.input = this.theme.getFormInputField('text')
    this.usingTagsFormat = this.schema.format === 'tags'

    if (this.options.input_width) this.input.style.width = this.options.input_width

    this.input
      .addEventListener('change', e => {
        e.preventDefault()
        e.stopPropagation()

        const val = e.currentTarget.value

        /* sanitize value */
        const sanitized = this.sanitize(val)
        if (val !== sanitized) {
          e.currentTarget.value = sanitized
        }

        this.is_dirty = true

        this.refreshValue()
      })
    this.input.addEventListener('blur', e => {
      if (this.usingTagsFormat) {
        this.choices.clearInput() // clear anything typed that wasn't turned into a tag via the enter key
      }
    })

    this.header = document.createElement('span')
    this.header.textContent = this.getTitle()
    this.title = this.theme.getHeader(this.header)
    this.container.appendChild(this.title)

    this.control = this.theme.getFormControl(this.label, this.input, this.description, this.infoButton, this.formname)
    this.container.appendChild(this.control)

    if (this.usingTagsFormat) {
      this.choices = new Choices(this.input, {
        addItems: true,
        duplicateItemsAllowed: false,
        delimiter: ',',
        editItems: true,
        removeItemButton: true
      })

      this.choices.input.element.addEventListener('blur', (e) => {
        this.choices.clearInput() // clear anything typed that wasn't turned into a tag via the enter key
      })
    }

    this.refreshValue()
  }

  // get comma separated values and turn into array, removing any empty values and duplicates
  getCleanedArrayFromString (str) {
    if (typeof str !== 'string') {
      throw new Error('Value must be a string')
    }

    return _.uniq(str.split(',').map((x) => x.trim()).filter((x) => x))
  }

  setValue (value, initial) {
    if (value === null) value = ''
    else if (Array.isArray(value)) {
      value = value.join(',')
    }

    if (typeof value !== 'string') {
      throw new Error('Value must be a string')
    }

    this.value = this.getCleanedArrayFromString(value).join(',')
    this.input.value = this.value
    this.refreshValue()

    if (initial) this.is_dirty = false
  }

  refreshValue () {
    this.value = this.input.value
    // this.value = this.input.value

    if (this.usingTagsFormat) {
      const arrayOfValues = this.getCleanedArrayFromString(this.value)
      this.choices.clearStore()
      this.choices.setValue(arrayOfValues)
    }

    this.onChange(true)
  }

  // this.value is a string, but this should always return an array
  getValue () {
    const hasValueSet = !!(this.input && this.input.value)
    // console.log('hasvalueset', hasValueSet)
    if (!hasValueSet) {
      return []
    }

    // get comma separated values from input and turn into array, removing any empty values and duplicates
    const arrValue = this.getCleanedArrayFromString(this.value)
    return arrValue
  }
}

export default CSVArray
